const phoneNumberOnly = e => {
  const char = String.fromCharCode(e.charCode);

  // Allow digits (0–9) and '+'
  if (!/[0-9+]/.test(char)) {
    e.preventDefault();
  }
};

export default {
  name: 'phone-number',
  bind(el) {
    el.addEventListener('keypress', phoneNumberOnly);
  },
  unbind(el) {
    el.removeEventListener('keypress', phoneNumberOnly);
  }
};
